"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_transition_group_1 = require("react-transition-group");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const models_1 = require("@completeanatomy/models");
const preferences_1 = require("@completeanatomy/preferences");
const ui_1 = require("@completeanatomy/ui");
const DropDownMenuItem_1 = __importDefault(require("../DropDownMenuItem"));
const UndoRedoMenuItem_1 = __importDefault(require("../UndoRedoMenuItem"));
function UndoRedoDropDown({ className, visible = false, isUndoMenu, hideDropdownCb, }) {
    const dropDownRef = (0, react_1.useRef)(null);
    (0, ui_1.useOutsideClick)(dropDownRef, hideDropdownCb, undefined, {
        stopPropagation: true,
    });
    const { isMobile } = (0, device_1.usePlatform)();
    const theme = (0, styled_components_1.useTheme)();
    const [listItems, setListItems] = (0, react_1.useState)([]);
    const [hasUndoMenu, setHasUndoMenu] = (0, react_1.useState)(false);
    const redoItems = (0, models_1.useRedoItems)();
    const undoItems = (0, models_1.useUndoItems)();
    const isUndoAllActive = (0, models_1.useUndoAllActive)();
    const isClearAllActive = (0, models_1.useClearAllActive)();
    const isTabsButtonAvailable = (0, preferences_1.useIsPreferenceActive)(bridge_schema_1.PreferenceBoolOption.ShowTabs);
    const bridge = (0, bridge_1.useBridge)();
    const items = isUndoMenu ? undoItems : redoItems;
    const showUndoAll = hasUndoMenu && isUndoAllActive;
    const showClearAllTools = hasUndoMenu && isClearAllActive;
    const onMenuItemClick = (0, react_1.useCallback)((identifier) => {
        bridge === null || bridge === void 0 ? void 0 : bridge.historyRestoreItem({ identifier });
        hideDropdownCb();
    }, [bridge, hideDropdownCb]);
    const onClearAllClick = (0, react_1.useCallback)(() => {
        bridge === null || bridge === void 0 ? void 0 : bridge.toolkitClearAllTools();
        hideDropdownCb();
    }, [bridge, hideDropdownCb]);
    const onUndoAllClick = (0, react_1.useCallback)(() => {
        bridge === null || bridge === void 0 ? void 0 : bridge.historyUndoAllPressed();
        hideDropdownCb();
    }, [bridge, hideDropdownCb]);
    const children = listItems === null || listItems === void 0 ? void 0 : listItems.map((item, index) => {
        const onClick = () => {
            if (item.isRestorable) {
                return onMenuItemClick(item.identifier);
            }
            hideDropdownCb();
        };
        if (item.identifier < 0) {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)(ItemsContainer, { "data-e2e": 'UndoRedoDropDown_ItemsContainer', children: (0, jsx_runtime_1.jsxs)(DropDownMenuItem_1.default, { onClick: onClick, "$isRestorable": !!item.isRestorable, "data-e2e": 'UndoRedoDropDown_DropDownMenuItem', children: [item.title, (0, jsx_runtime_1.jsx)(ui_1.Ripple, { color: theme.ripple, duration: 700, "data-e2e": 'UndoRedoDropDown_Ripple' })] }) }, index));
    });
    (0, react_1.useEffect)(() => {
        if (visible) {
            setListItems(items);
            setHasUndoMenu(isUndoMenu);
        }
        if (children.length && !visible) {
            setTimeout(() => {
                setListItems([]);
                setHasUndoMenu(false);
            }, 500);
        }
    }, [visible, items, isUndoMenu, children.length]);
    return ((0, jsx_runtime_1.jsx)(Container, { "$hasTabs": isTabsButtonAvailable, "$isMobile": isMobile, "data-e2e": 'UndoRedoDropDown_Container', children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: !!children.length && visible, timeout: 500, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'UndoRedoDropDown_CSSTransition', children: (0, jsx_runtime_1.jsxs)(DropDownMenuContainer, { className: className, ref: dropDownRef, "data-e2e": 'UndoRedoDropDown_DropDownMenuContainer', children: [(0, jsx_runtime_1.jsx)(StyledScrollView, { "data-e2e": 'UndoRedoDropDown_StyledScrollView', children: children }), showClearAllTools && ((0, jsx_runtime_1.jsx)(UndoRedoMenuItem_1.default, { onClick: onClearAllClick, "data-e2e": 'UndoRedoDropDown_UndoRedoMenuItem', children: (0, i18n_1.Localized)(i18n_1.Strings.undoRedo.clearAll) })), showUndoAll && ((0, jsx_runtime_1.jsx)(UndoRedoMenuItem_1.default, { onClick: onUndoAllClick, "data-e2e": 'UndoRedoDropDown_UndoRedoMenuItem', children: (0, i18n_1.Localized)(i18n_1.Strings.undoRedo.undoAll) }))] }) }) }));
}
exports.default = UndoRedoDropDown;
const Container = styled_components_1.default.div `
  left: ${({ $hasTabs, $isMobile }) => (!$isMobile && $hasTabs ? '-40px' : 0)};
  overflow: hidden;
  position: absolute;
  top: 100%;
  z-index: 1;
`;
const DropDownMenuContainer = styled_components_1.default.div `
  width: 250px;
  background-color: ${({ theme }) => theme.background};

  border: 1px solid ${({ theme }) => theme.dropdown.line};

  transform: translateY(-150%);
  transition: transform 0.2s ease-in-out;

  pointer-events: initial;

  &.enter {
    transform: translateY(-150%);
  }

  &.enter-active {
    transform: translateY(0);
  }

  &.enter-done {
    transform: translateY(0);
  }

  &.exit-active {
    transform: translateY(-150%);
  }
`;
const ItemsContainer = styled_components_1.default.div `
  position: relative;
`;
const StyledScrollView = (0, styled_components_1.default)(ui_1.ScrollView) `
  display: flex;
  flex-direction: column;

  max-height: 300px;
`;
